/**
 * Curated executive points of view — LinkedIn posts and Shared Oxygen briefs.
 * Prefer Shared Oxygen URLs when the full brief lives on the site (LinkedIn → sharedoxygen.com).
 */
export const linkedInPointOfViews = [
  {
    id: 'ai-trust-stack',
    title: 'The AI Stack Is Becoming A Trust Stack',
    excerpt:
      'When AI reaches for the keyboard, intelligence stops being the bottleneck. Trust does. Suggestion ends where commitment begins.',
    url: 'https://sharedoxygen.com/blog/ai-stack-becoming-trust-stack',
    publishedDate: '2026-08-22',
    imageUrl: '/images/blog/ai-trust-stack-linkedin.svg',
    imageAlt: 'Authority at the boundary — suggestion ends where commitment begins',
    source: 'Shared Oxygen',
    author: 'Jeffrey Collins',
  },
  {
    id: 'outcomes-per-token-board-kpi',
    title: 'Outcomes Per Token Is The Board-Level KPI',
    excerpt:
      "Shared Oxygen ran 3B tokens across frontier, mid-tier, and local LLMs as deliberate research into AI economics — roughly five developer-years of usage. Token volume is a poor proxy for value. Outcomes-per-token is the real board-level KPI, and model tier selection is a capital allocation decision. Not a usage story — an evidence story. Can you defend what you're spending?",
    url: 'https://www.linkedin.com/posts/sharedoxygen_ai-enterpriseai-cto-activity-7480464511028637696-imTu/',
    publishedDate: '2026-07-08',
    imageUrl: '/images/outcomes-per-token-linkedin.svg',
    imageAlt:
      'Outcomes Per Token Is The Board-Level KPI — Shared Oxygen AI economics research',
    source: 'LinkedIn',
    author: 'Jeffrey Collins',
  },
];
